import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { PriceHistoryResponse } from 'src/app/models/price-History-response.model'

@Injectable({
  providedIn: 'root',
})
export class PriceHistoryService {
  public static readonly priceHistoryEndpoint = '/price-history'
  public responseCache = new Map()
  constructor(private readonly http: HttpClient) {}

  getPriceHistory(
    fundId: string,
    range: string,
  ): Observable<PriceHistoryResponse> {
    const historyEndpoint = PriceHistoryService.priceHistoryEndpoint.concat(
      `/${range}`,
    )
    return this.http.get<PriceHistoryResponse>(
      `vmf/api/${fundId}`.concat(historyEndpoint),
    )
  }
}
